import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import marquee3k from 'marquee3000/marquee3k.min.js'
Object.defineProperty(Vue.prototype, '$marquee3k', { value: marquee3k })

import VueMoment from 'vue-moment'

Vue.use(VueMoment, VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')